export default "__VITE_ASSET__CN5w3u2i__"